import React from 'react';

const Skills = () => {
  const skillCategories = [
    { name: "Web Development", skills: ["HTML/CSS", "React JS", "Tailwind CSS", "JavaScript"] },
    { name: "Data & Machine Learning", skills: ["Python", "Data Preprocessing", "Algorithm Comparison", "Model Evaluation"] },
    { name: "Networking & Security", skills: ["Cisco Router Config", "Cryptography (Ciphers)", "PicoCTF", "Troubleshooting"] }
  ];

  return (
    <section id="skills" className="my-16 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md transition-colors duration-300">
      <h2 className="text-3xl font-semibold text-blue-600 dark:text-blue-400 mb-6">Technical Skills</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {skillCategories.map((cat, index) => (
          <div key={index} className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg shadow-sm">
            <h3 className="text-lg font-bold text-gray-800 dark:text-white mb-3 border-b pb-2">{cat.name}</h3>
            <ul className="space-y-2">
              {cat.skills.map((skill, i) => (
                <li key={i} className="flex items-center text-gray-700 dark:text-gray-300">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-2 animate-pulse"></span>
                  {skill}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;